import React, { useEffect, useState } from 'react';
import DockVerticalDerecha from '../estructura/DockVerticalDerecha';
import { toast } from 'react-toastify';
import instanciaAxios, { esErrorPermiso } from '../../miscelaneo/instanciaAxios';
import PlantillaModal from '../util/PlantillaModal';
import TablaCategoria from '../util/tablas/TablaCategoria';

function MantenimientoCategoria() {
    const [formData, setFormData] = useState({});
    const [estados, setEstados] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [modo, setModo] = useState('creacion');
    const [editable, setEditable] = useState(true);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
    const [mostrarModalCategoria, setMostrarModalCategoria] = useState(false);
    // Deshabilita el botón "Guardar" mientras se espera la respuesta del backend
    // (evita que un doble clic duplique la categoría).
    const [guardando, setGuardando] = useState(false);

    const handleChange = (e) => {
        const { id, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: type === 'checkbox' ? checked : value,
        }));
    };

    useEffect(() => {
        setEditable(modo !== 'ver');
        setCategoriaSeleccionada(null);
        const mensajes = {
            'ver': 'Modo solo observación',
            'edicion': 'Modo edición',
            'creacion': 'Modo creación'
        };
        toast.info(mensajes[modo]);
    }, [modo]);

    useEffect(() => {
        const fetchEstados = async () => {
            try {
                const response = await instanciaAxios.get('/miscelaneo/estado');
                setEstados(response.data);
            } catch (error) {
                if (esErrorPermiso(error)) return;
                console.error('Error al cargar estados:', error);
                toast.error('Error al cargar los estados');
            } finally {
                setCargando(false);
            }
        };
        fetchEstados();
    }, []);

    const campos = [
        { id: "descripcion", type: "text", label: "*Descripción", placeholder: "Descripción", seccion: "Información de categoría" },
        {
            id: "id_estado",
            label: "Estado",
            placeholder: "Estado",
            type: "select",
            opciones: estados.map(estado => ({ label: estado.descripcion, value: estado.id_estado })),
            seccion: "Información de categoría"
        }
    ];

    const camposPorSeccion = campos.reduce((acc, campo) => {
        if (!acc[campo.seccion]) acc[campo.seccion] = [];
        acc[campo.seccion].push(campo);
        return acc;
    }, {});

    async function SubmitCategoria() {
        if (guardando) return;
        const errores = [
            { cond: !formData.descripcion, msg: 'El campo descripción es obligatorio' },
            { cond: !formData.id_estado, msg: 'Debe seleccionar un estado' },
        ];

        for (let error of errores) {
            if (error.cond) {
                toast.error(error.msg);
                return;
            }
        }

        try {
            let id_categoria_ = formData.id_categoria;
            const payload = { ...formData };

            if (modo === 'ver') {
                toast.info('Modo solo observación. No se puede guardar.');
                return;
            }

            setGuardando(true);

            if (modo === 'creacion') {

                const res = await instanciaAxios.post('/miscelaneo/categoria', payload);
                id_categoria_ = res.data.id_categoria;

                setFormData(prev => ({
                    ...prev,
                    id_categoria: id_categoria_,
                }));

                toast.success('Categoría registrada con éxito');
            }

            if (modo === 'edicion') {
                await instanciaAxios.put('/miscelaneo/categoria', payload);
                toast.success('Categoría editada con éxito');
            }

            setModo('ver');
        } catch (error) {
            if (esErrorPermiso(error)) return;
            toast.error('Error al guardar la categoría');
            console.error(error);
        } finally {
            setGuardando(false);
        }
    }

    const handleBotonBuscar = async () => {
        setMostrarModalCategoria(true);
        setModo('ver');
    };

    const handleSeleccionarCategoria = (categoria) => {
        setCategoriaSeleccionada(categoria);
        setFormData(categoria);
        setMostrarModalCategoria(false);
    };

    const handleBotonEditar = () => {
        setMostrarModalCategoria(true);
        setModo('edicion');
    };

    const handleBotonCrear = () => {
        setModo('creacion');
        setFormData({});
    };

    return (
        <div className="bg-gray-200 min-h-screen">
            <div className="flex justify-center py-10">
                <div className="bg-gray-100 bg-opacity-90 rounded-xl border border-gray-100 p-12 w-full max-w-7xl mx-10">
                    <form className="flex flex-col gap-8">
                        <div className="space-y-1">
                            <h1 className="font-cascadia font-bold text-2xl">Categoría</h1>
                            <p className="text-gray-500">Complete los campos y administre la información de cada categoría.</p>
                        </div>
                        {Object.entries(camposPorSeccion).map(([titulo, campos]) => (
                            <div key={titulo}>
                                <h2 className="text-lg font-semibold mb-4">{titulo}</h2>
                                <div className="grid gap-4 grid-cols-[repeat(auto-fit,_minmax(230px,_1fr))]">
                                    {campos.map((campo) => (
                                        <div key={campo.id} className="flex flex-col">
                                            <label htmlFor={campo.id} className="text-sm font-medium text-gray-600 mb-1">
                                                {campo.label}
                                            </label>
                                            {campo.type === "select" ? (
                                                <select
                                                    id={campo.id}
                                                    value={formData[campo.id] || ""}
                                                    onChange={handleChange}
                                                    disabled={!editable}
                                                    className="w-full p-2 rounded-xl text-gray-700 border border-gray-400"
                                                >
                                                    <option value="">Seleccione una opción</option>
                                                    {campo.opciones?.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            ) : (
                                                <input
                                                    type={campo.type}
                                                    id={campo.id}
                                                    value={formData[campo.id] || ""}
                                                    onChange={handleChange}
                                                    placeholder={campo.placeholder}
                                                    disabled={!editable}
                                                    className="w-full p-2 rounded-xl text-gray-700 border border-gray-400"
                                                />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </form>

                    <DockVerticalDerecha
                        handleBotonGuardar={(e) => SubmitCategoria(e)}
                        handleBotonCrear={handleBotonCrear}
                        handleBotonBuscar={handleBotonBuscar}
                        handleBotonEditar={handleBotonEditar}
                        guardando={guardando}
                    />

                    <PlantillaModal
                        mostrar={mostrarModalCategoria}
                        onClose={() => setMostrarModalCategoria(false)}
                    >
                        <TablaCategoria
                            descripcion={'Seleccione la categoría para ver o editar.'}
                            setCategoriaSeleccionada={handleSeleccionarCategoria}
                        />
                    </PlantillaModal>
                </div>
            </div>
        </div>
    );
}

export default MantenimientoCategoria;
